// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { Box, Typography } from '@mui/material';
// import TableComponent from '../../Components/TableComponent/TableComponent';
// import { SnackBarComponent } from '../../Components/snackBar/snackBar';
// import { LoadingSpinner } from '../../Components/spinner/spinner';
// import { API_BASE_URL } from '../../config';
// import { useTranslation } from 'react-i18next';

// export const DailyHighCourtCasesComponent = () => {
//   const { t } = useTranslation();

//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('info');

//   const columns = [


//     { id: 'slNo', field: 'slNo',headerName: t('highCourt.slNo'), width: 20 },
//     { id: 'case_no', field: 'case_no',headerName: t('highCourt.caseNo'), width: 100 },
//     { id: 'name_of_the_parties', field: 'name_of_the_parties',  headerName: t('highCourt.nameOfParties'), width: 150 },
//     { id: 'advocate_name', field: 'advocate_name', headerName: t('highCourt.advocateName'), width: 160 },
//     { id: 'fe', field: 'fe', headerName: t('highCourt.fe'), width: 80 },
//     { id: 'date_of_filling', field: 'date_of_filling', headerName: t('highCourt.dateOfFilling'), width: 100 },
//     { id: 'previous_date_of_hearing', field: 'previous_date_of_hearing', headerName: t('highCourt.previousDate'), width: 150 },
//     { id: 'next_date_of_hearing', field: 'next_date_of_hearing', headerName: t('highCourt.nextDate'), width: 150 },
//     { id: 'appearence_by', field: 'appearence_by', headerName: t('highCourt.apearenceBY'), width: 120 },
//     { id: 'status', field: 'status', headerName: t('highCourt.status'), width: 100 },

//   ];

//   useEffect(() => {
//     axios
//       .get(`${API_BASE_URL}/home-notification/daily-high-court-cases/`)
//       .then((response) => {
//         const apiData = response.data.map((item, index) => ({
//           id: item.id || index,
//           slNo: index + 1,
//           case_no: item.case_no,
//           name_of_the_parties: item.name_of_the_parties,
//           fe: item.fe,
//           date_of_filling: new Date(item.date_of_filling).toLocaleDateString('en-GB').replace(/\//g, '-'),
//           status: item.status,
//           previous_date_of_hearing: new Date(item.previous_date_of_hearing).toLocaleDateString('en-GB').replace(/\//g, '-'),
//           next_date_of_hearing: new Date(item.next_date_of_hearing).toLocaleDateString('en-GB').replace(/\//g, '-'),
//           advocate_name: item.advocate_name || '',
//           appearence_by: item.appearence_by || '',
//           // links: item.link,
//         }));
//         setRows(apiData);
//         setSnackbarMessage(t('highCourt.successMessage'));
//         setSnackbarSeverity('success');
//         setSnackbarOpen(true);
//         setLoading(false);
//       })
//       .catch((error) => {
//         console.error('Failed to fetch daily High court cases:', error);
//         setSnackbarMessage(t('highCourt.errorMessage'));
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//         setLoading(false);
//       });
//   }, [t]);

//   const handleSnackbarClose = () => {
//     setSnackbarOpen(false);
//   };

//   if (loading) {
//     return <LoadingSpinner size={30} />;
//   }

//   return (
//     <Box
//       sx={{
//         width: '100%',
//         mt: 8,
//         mb: 1,
//         borderRadius: 2,
//         boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
//         backgroundColor: '#fff',
//       }}
//     >
//       <Box display="flex" justifyContent="center" backgroundColor="rgba(195, 234, 203, 0.1)" mb={2}>
//         <Typography variant="h4" component="h1" align="center" sx={{ fontWeight: 'bold' }}>
//           {t('highCourt.heading')}
//         </Typography>
//       </Box>

//       <TableComponent
//         columns={columns}
//         rows={rows}
//         manageColumnStatus={true}
//         enableSort={true}
//         sx={{
//           '& .MuiDataGrid-columnHeaders': {
//             backgroundColor: '#1976d2',
//             color: '#fff',
//             fontWeight: 'bold',
//           },
//         }}
//       />

//       <SnackBarComponent
//         open={snackbarOpen}
//         message={snackbarMessage}
//         severity={snackbarSeverity}
//         onClose={handleSnackbarClose}
//       />
//     </Box>
//   );
// };



import React, { useEffect, useState, useMemo } from 'react';
import axios from 'axios';
import { Box, Typography, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import TableComponent from '../../Components/TableComponent/TableComponent';
import { SnackBarComponent } from '../../Components/snackBar/snackBar';
import { LoadingSpinner } from '../../Components/spinner/spinner';
import { API_BASE_URL } from '../../config';
import { useTranslation } from 'react-i18next';

export const DailyHighCourtCasesComponent = () => {
  const { t } = useTranslation();

  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('info');
  const [selectedStatus, setSelectedStatus] = useState('all');

  const columns = [
    { id: 'slNo', field: 'slNo', headerName: t('highCourt.slNo'), width: 20 },
    { id: 'case_no', field: 'case_no', headerName: t('highCourt.caseNo'), width: 100 },
    { id: 'name_of_the_parties', field: 'name_of_the_parties', headerName: t('highCourt.nameOfParties'), width: 150 },
    { id: 'advocate_name', field: 'advocate_name', headerName: t('highCourt.advocateName'), width: 160 },
    { id: 'fe', field: 'fe', headerName: t('highCourt.fe'), width: 80 },
    { id: 'date_of_filling', field: 'date_of_filling', headerName: t('highCourt.dateOfFilling'), width: 100 },
    { id: 'previous_date_of_hearing', field: 'previous_date_of_hearing', headerName: t('highCourt.previousDate'), width: 150 },
    { id: 'next_date_of_hearing', field: 'next_date_of_hearing', headerName: t('highCourt.nextDate'), width: 150 },
    { id: 'appearence_by', field: 'appearence_by', headerName: t('highCourt.apearenceBY'), width: 120 },
    { id: 'status', field: 'status', headerName: t('highCourt.status'), width: 120 },
    // {
    //   id: 'links',
    //   field: 'links',
    //   headerName: t('advertisement.links'),
    //   width: 120,
    //   renderCell: (params) => (
    //     <a href={params.value} target="_blank" rel="noopener noreferrer">
    //       {t('advertisement.download')}
    //     </a>
    //   ),
    // },
    {
  id: 'links',
  field: 'links',
  headerName: t('advertisement.links'),
  width: 120,
  renderCell: (params) => {
    if (!params.value) {
      return <span>Not Found</span>;
    }
    return (
      <a href={params.value} target="_blank" rel="noopener noreferrer">
        {t('advertisement.download')}
      </a>
    );
  },
},

  ];



    // Safe date formatter - returns original value if invalid
  const formatDate = (dateString) => {
    if (!dateString || typeof dateString !== 'string') return dateString || '-';
    
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString; // Return original if invalid
    
    return date.toLocaleDateString('en-GB').replace(/\//g, '-');
  };

  // Normalize to match api data and for internal comparisons
  const normalizeStatus = (status) => {
    if (!status) return '';
    return status.toLowerCase().replace(/\s+/g, '').replace(/[-]/g, '');
  };

  // Spelling correction map (normalized keys)
  const statusCorrectionMap = {
    notiece: 'notice',
    'non-comlians': 'noncompliance',
    'non-clians': 'noncompliance',
  };

  // Display names keyed by normalized status
  const statusDisplayNames = {
    finalhearing: 'Final hearing',
    admission: 'Admission',
    hearingonia: 'Hearing on IA',
    orders: 'Orders',
    preliminaryhearingbgroup: 'Preliminary hearing B-group',
    noncompliance: 'Non-compliance',
    notice: 'Notice',
    disposed: 'Disposed',
    reservedforjudgement: 'Reserved for judgement',
    furtherhearing: 'Further hearing',
    freshmatters: 'Fresh matters',
    preliminaryhearing: 'Preliminary hearing'
  };

  // Map API status to a user-friendly, displayable status
  const getDisplayStatus = (originalStatus) => {
    if (!originalStatus) return '';
    const normalized = normalizeStatus(originalStatus);
    const corrected = statusCorrectionMap[normalized] || normalized;
    return statusDisplayNames[corrected] || originalStatus;
  };

  // Priority statuses in normalized form (to be matched against data)
  const priorityStatuses = [
    'finalhearing',
    'admission',
    'hearingonia',
    'orders',
    'preliminaryhearingbgroup',
    'noncompliance',
    'notice',
    'disposed',
    'reservedforjudgement',
    'furtherhearing',
    'freshmatters',
    'preliminaryhearing'
  ];

  // Get unique normalized statuses from data
  const getUniqueStatuses = (data) => {
    const statusSet = new Set();
    data.forEach((item) => {
      if (item.normalizedStatus) {
        statusSet.add(item.normalizedStatus);
      }
    });
    return Array.from(statusSet);
  };

  // Fetch data on mount
  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/home-notification/daily-high-court-cases/`)
      .then((response) => {
        const apiData = response.data.map((item, index) => ({
          id: item.id || index,
          slNo: index + 1,
          case_no: item.case_no,
          name_of_the_parties: item.name_of_the_parties,
          fe: item.fe,
          date_of_filling: formatDate(item.date_of_filling),
          status: getDisplayStatus(item.status),
          originalStatus: item.status || '',
          normalizedStatus: normalizeStatus(item.status),
          previous_date_of_hearing: formatDate(item.previous_date_of_hearing), 
          next_date_of_hearing: formatDate(item.next_date_of_hearing), 
          advocate_name: item.advocate_name || '',
          appearence_by: item.appearence_by || '',
          links: item.link || '',
        }));
        setRows(apiData);
        setFilteredRows(apiData);
        setSnackbarMessage(t('highCourt.successMessage'));
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Failed to fetch daily High court cases:', error);
        setSnackbarMessage(t('highCourt.errorMessage'));
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        setLoading(false);
      });
  }, [t]);

  // Filter rows when status changes
  useEffect(() => {
    if (selectedStatus === 'all') {
      setFilteredRows(rows);
    } else if (selectedStatus === 'others') {
      const prioritySet = new Set(priorityStatuses);
      const otherRows = rows.filter((row) => row.normalizedStatus && !prioritySet.has(row.normalizedStatus));
      setFilteredRows(otherRows);
    } else {
      const filtered = rows.filter((row) => row.normalizedStatus === selectedStatus);
      setFilteredRows(filtered);
    }
  }, [rows, selectedStatus]);

  // Build status options based on data
  const statusOptions = useMemo(() => {
    const uniqueStatuses = getUniqueStatuses(rows);
    const options = ['all'];

    // Include priority statuses that exist in data
    priorityStatuses.forEach((status) => {
      if (uniqueStatuses.includes(status)) {
        options.push(status);
      }
    });

    // Include any non-priority statuses as "others"
    const hasOthers = uniqueStatuses.some((s) => !priorityStatuses.includes(s));
    if (hasOthers) {
      options.push('others');
    }

    return options;
  }, [rows]);

  const handleStatusChange = (event) => {
    setSelectedStatus(event.target.value);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  if (loading) {
    return <LoadingSpinner size={30} />;
  }

  return (
    <Box
      sx={{
        width: '100%',
        mt: 8,
        mb: 1,
        borderRadius: 2,
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        backgroundColor: '#fff',
        position: 'relative',
      }}
    >
      <Box display="flex" justifyContent="center" backgroundColor="rgba(195, 234, 203, 0.1)" mb={2}>
        <Typography variant="h4" component="h1" align="center" sx={{ fontWeight: 'bold' }}>
          {t('highCourt.heading')}
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'flex-end', px: 2, mb: 1 }}>
        <FormControl size="small" sx={{ minWidth: 140 }}>
          <InputLabel sx={{ fontSize: '0.75rem' }}>Status</InputLabel>
          <Select value={selectedStatus} label="Status" onChange={handleStatusChange} sx={{ fontSize: '0.8rem' }}>
            <MenuItem value="all">All</MenuItem>
            {statusOptions
              .filter((opt) => opt !== 'all' && opt !== 'others')
              .map((status) => (
                <MenuItem key={status} value={status} sx={{ fontSize: '0.8rem' }}>
                  {statusDisplayNames[status] || status}
                </MenuItem>
              ))}
            {statusOptions.includes('others') && <MenuItem value="others">Others</MenuItem>}
          </Select>
        </FormControl>
      </Box>

      <TableComponent
        columns={columns}
        rows={filteredRows}
        manageColumnStatus={true}
        enableSort={true}
      />

      <SnackBarComponent open={snackbarOpen} message={snackbarMessage} severity={snackbarSeverity} onClose={handleSnackbarClose} />
    </Box>
  );
};
